"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.compareVersion = exports.parseVersion = exports.extractVersion = exports.MYPLACE_SDK_REGEX = exports.NAVER_APP_REGEX = void 0;
const R = __importStar(require("ramda"));
exports.NAVER_APP_REGEX = 'NAVER\\(';
exports.MYPLACE_SDK_REGEX = 'myplace-sdk-(?:android|ios)/';
/**
 * user-agent 값에서 버전 문자열을 추출해내는 함수, patch 버전 까지만 추출합니다.
 */
const extractVersion = (pattern) => (userAgent) => R.pipe(R.match(new RegExp(`${pattern}.*?(\\d+\\.\\d+(\\.\\d+)?)`)), // 패턴에서 버전 x.x(.x)? 만 추출
R.nth(1), // 첫 번째 그룹 (괄호 안의 내용) 선택
R.ifElse(R.isNil, // 만약 null이나 undefined이면
R.always(null), // null 반환
R.identity))(userAgent);
exports.extractVersion = extractVersion;
/**
 * 버전 문자열을 파싱하여 [major, minor, patch]의 숫자 배열로 리턴합니다.
 * 세자리를 보장하고, 값이 없거나 숫자가 아닐 경우 0으로 대체합니다.
 *
 * @param versionString - 버전 문자열
 * @returns [number, number, number]
 */
exports.parseVersion = R.pipe(R.defaultTo(''), R.split('.'), R.map(R.pipe(Number, R.defaultTo(0))), // 숫자로 만들기, 파싱 실패의 경우 0으로 만들기
// 숫자로 만들기, 파싱 실패의 경우 0으로 만들기
parts => R.times(idx => { var _a; return (_a = parts[idx]) !== null && _a !== void 0 ? _a : 0; }, 3));
const compareVersion = (baseVersion, compareFn) => (version) => {
    const [baseMajor, baseMinor, basePatch] = (0, exports.parseVersion)(baseVersion);
    const [major, minor, patch] = (0, exports.parseVersion)(version !== null && version !== void 0 ? version : '');
    if (major !== baseMajor)
        return compareFn(major, baseMajor);
    if (minor !== baseMinor)
        return compareFn(minor, baseMinor);
    if (patch !== basePatch)
        return compareFn(patch, basePatch);
    return compareFn(0, 0);
};
exports.compareVersion = compareVersion;
